exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lmdy0YQ8INQZqbcglkwST{outline:none;min-width:0;min-height:0;overflow-y:hidden}html[dir] .lmdy0YQ8INQZqbcglkwST{border-radius:4px}.lmdy0YQ8INQZqbcglkwST .ms-Modal-scrollableContent{overflow-y:hidden;max-height:95vh}", ""]);
// Exports
exports.locals = {
	"dialog": "lmdy0YQ8INQZqbcglkwST"
};